module.exports = __webpack_public_path__ + "static/media/inetcpl_1319.ae56ac02.ico";